module.exports = __webpack_public_path__ + "img/grid-6.b1ad1b70.svg";